angular.module('leanlaw').controller('ContingencyReportDetailSidebarCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts) {
  $scope.filter = {
    include: {}
  };
  $scope.filter.include.detail = false;

  // userService.me().then(me => {
  //     $scope.expenseInterest = me.company.settings.fees && me.company.settings.fees.expenseInterest;
  // })

  // Fires immediately on filter creation
  $scope.$watch("filter", (newValue, oldValue) => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);
}]);